export enum PRIMARY_BUTTON_SIZE {
  sm = "px-12",
  md = "px-24",
  lg = "px-36",
}
